export class TopicLinks {
  topicLink = ''
  articleLink = ''
}
